// create option "ALL" for user to see all the agents, this doesn't has on the backend.
export const agentAll = {
    razaoSocial: 'Todos',
    id: '',
    dataCriacao: '',
    dataAlteracao: '',
    cnpj: '',
    uf: '',
    codigo: '',
    categorizacao: '',
    instituicaoPagaTaxa: false,
    dataFimVigencia: '',
    dataInicioVigencia: ''
}

// create option "ALL" for user BACKOFFICE to see all the instituitions, this doesn't has on the backend..
export const institutionAll = {
    id: '',
    guid: '',
    razaoSocial: 'Todos',
    cnpj: '',
    email: '',
    telefone: '',
    codigo: '',
    enderecos: [],
    responsaveisLegais: []
}
